import { AudienceManager } from '../audience-manager';
import { SelectAudienceErrorButton, SelectAudienceLoadingButton } from '../select-audience-button';
import { IAudienceContainer } from './types';
import { memo } from 'react';

export const AudienceContainer = memo(({ isLoading, isError, ...rest }: IAudienceContainer) => {
  if (isError) {
    return <SelectAudienceErrorButton />;
  }

  if (isLoading) {
    return <SelectAudienceLoadingButton />;
  }

  return <AudienceManager {...rest} />;
});
